import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {Router} from "@angular/router";
import {AuthService} from "../../../shared/services/auth.service";
import {takeUntil} from "rxjs/operators";
import {Terminals} from "../../../shared/interface/terminals";
import {ConfirmDialogComponent} from "../../../shared/components/confirm-dialog/confirm-dialog.component";
import {TerminalsService} from "../../../shared/services/terminals.service";
import {
  ChangeTerminalsImportRowDialogComponent
} from "../change-terminals-import-row-dialog/change-terminals-import-row-dialog.component";
import {
  TERMINAL_STATUS_TO_BE_REALIZED,
} from "../../../shared/services/dict.service";
import {
  ConfirmDialogWithReasonComponent
} from "../../../shared/components/confirm-dialog-with-reason/confirm-dialog-with-reason.component";
import {HttpErrorResponse} from "@angular/common/http";
import {TerminalsNoteAddComponent} from "../terminals-note-add/terminals-note-add.component";

@Component({
  selector: 'app-terminals-details-view',
  templateUrl: './terminals-details-view.component.html',
  styleUrls: ['./terminals-details-view.component.scss']
})
export class TerminalsDetailsViewComponent  implements OnInit, OnDestroy {
  @Input() terminals: Observable<Terminals>;
  @Output() modifyClicked = new EventEmitter<any>();
  @Output() modifyClickedEdit = new EventEmitter<any>();

  readonly TERMINAL_STATUS_TO_BE_REALIZED = TERMINAL_STATUS_TO_BE_REALIZED;

  terminalsObject?: Terminals;
  userPermissions: ReplaySubject<UserPermissions>;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  constructor(
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private router: Router,
    private auth: AuthService,
    private terminalsService: TerminalsService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.terminals
      .pipe(takeUntil(this.destroyed$))
      .subscribe((terminals: Terminals) => {
        this.terminalsObject = terminals;
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
  delete(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć polisę?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.terminalsService.delete(this.terminalsObject.uuid)
          .subscribe(() => {
            this.snack.open('Pomyślnie usunięto polisę', '', {duration: 2000});
            this.router.navigate(['/terminale/polisy/lista']);
          });
      }
    });
  }

  terminalImportRowChange(): void {
    const dialogRef = this.dialog.open(ChangeTerminalsImportRowDialogComponent, {
      width: '700px',
      data: {
        terminalsObject: this.terminalsObject
      },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.modifyClicked.emit();
    });
  }


  modify(): void {
    this.modifyClickedEdit.emit();
  }

  statusChange(): void {
    const dialogRef = this.dialog.open(ConfirmDialogWithReasonComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz zmienić status polisy na \'Zapłacona\'?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result.reason) {
        this.terminalsService.statusChange(this.terminalsObject.uuid ,  result.reason)
          .subscribe({
            next: () => {
              this.snack.open('Pomyślnie zmieniono status', '', {duration: 2000});
              this.modifyClicked.emit();
            },
            error: (response: HttpErrorResponse) => {
              this.snack.open(response.error.error.text, response.status.toString(), {duration: 2000});
            }
          });
      }
    });
  }

  addNote(): void {
    const dialogRef = this.dialog.open(TerminalsNoteAddComponent, {
      width: '700px',
      data: {
        terminals: this.terminalsObject},
    });

    dialogRef.afterClosed().subscribe(() => {
      this.modifyClicked.emit();
    });
  }
}

